module.exports = __webpack_public_path__ + "img/icon-touxiangnan@2x.1d80bc34.png";